
































































































































































import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import SaveButton from './SaveButton.vue';
import TVButton from './TVButton.vue';
import { i18n } from '../../lang/i18n.config';

export default Vue.extend({
  name: 'PageHeading',
  components: { SaveButton, TVButton },
  props: {
    slug: {
      type: String,
      required: true,
      default: 'questions',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    currentSession: {
      type: Object,
      required: true,
    },
    showDescriptionField: {
      type: Boolean,
      required: false,
      default: true,
    },
    showButtonField: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonPlaceholder: {
      type: String,
      required: false,
      default: i18n.t('components.presenter.pageHeadingNewQuestions'),
    },
    hideTVButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      labels: 'presenter/getLabels',
      descriptions: 'presenter/getDescriptions',
      buttonLabels: 'presenter/getButtonLabels',
    }),
  },
  methods: {
    ...mapMutations({
      setLabel: 'presenter/SET_SESSION_LABEL',
      setDescription: 'presenter/SET_SESSION_DESCRIPTION',
      setButtonLabel: 'presenter/SET_SESSION_BUTTON_LABEL',
    }),

    inputValue(label: any, sessionLabel: any, placeholder: any): string {
      if (label[this.slug] || label[this.slug] === '') {
        return label[this.slug];
      }

      const hasStoredValue = sessionLabel && sessionLabel[this.slug];

      return hasStoredValue ? sessionLabel[this.slug] : placeholder;
    },

    saveLabel() {
      this.$store.dispatch('presenter/updateSessionLabel', {
        label: this.labels[this.slug],
        labelId: this.slug,
      });
    },
    saveDescription() {
      this.$store.dispatch('presenter/updateSessionDescription', {
        description: this.descriptions[this.slug],
        descriptionId: this.slug,
      });
    },
    saveButtonLabel() {
      this.$store.dispatch('presenter/updateSessionButtonLabel', {
        buttonLabel: this.buttonLabels[this.slug],
        buttonId: this.slug,
      });
    },
  },
});
